<template>
  <div class="compressed-content">
    <h3 class="page-question">Have you had any of the following? See pictures <br /> <i>(check all that apply)</i></h3>
    <b-form-group class="card-selector page-buttons">
      <b-img-lazy src="/png/thick-achilles.png" alt="thick achilles" fluid></b-img-lazy>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.hadThickAchilles"
                        @change="onHadThickAchillesSelected">
        Thick Achilles tendons
      </b-form-checkbox>

      <b-img-lazy src="/png/xanthomas.png" alt="xanthomas" fluid></b-img-lazy>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.hadXanthomas"
                        @change="onHadXanthomasSelected">
        Bumps or lumps around the knuckles, elbows, and knees, called “xanthomas”
      </b-form-checkbox>

      <b-img-lazy src="/png/corneal-arcus.png" alt="corneal arcus" fluid></b-img-lazy>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.hadCornealArcus"
                        @change="onHadCornealArcusSelected">
        White ring around the colored part of the eye (corneal arcus) before the age of 45
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    computed: {
      ...mapState(["survey"])
    },

    methods: {
      onHadThickAchillesSelected(value) {
        this.survey.bloodBiochemistry.hypercholesterolemia.hadThickAchilles = value;
      },

      onHadXanthomasSelected(value) {
        this.survey.bloodBiochemistry.hypercholesterolemia.hadXanthomas = value;
      },

      onHadCornealArcusSelected(value) {
        this.survey.bloodBiochemistry.hypercholesterolemia.hadCornealArcus = value;
      }
    }
  };
</script>